export default class MainCounterUp {
    constructor() {
        this.section = document.querySelector(".no-main-about");
        if (!this.section) return;

        this.init();
    }

    init() {
        const counterElements = this.section.querySelectorAll(
            ".no-main-about__content em"
        );

        counterElements.forEach((element) => {
            const text = element.textContent.trim();

            // 숫자인지 확인
            if (this.isNumeric(text)) {
                this.animateCounter(element, parseInt(text));
            }
        });
    }

    isNumeric(str) {
        // 숫자로만 구성되어 있는지 확인 (공백 제거 후)
        return /^\d+$/.test(str.replace(/\s/g, ""));
    }

    animateCounter(element, targetValue) {
        // 초기값을 0으로 설정
        const counter = { value: 0 };

        // ScrollTrigger로 스크롤 시 애니메이션 시작
        ScrollTrigger.create({
            trigger: this.section,
            start: "top center",
            once: true,
            onEnter: () => {
                // GSAP로 0에서 목표 숫자까지 카운트업
                gsap.to(counter, {
                    value: targetValue,
                    duration: 2,
                    ease: "power2.out",
                    onUpdate: () => {
                        // 소수점 제거하고 정수로 표시
                        element.textContent = Math.floor(counter.value);
                    },
                });
            },
        });
    }
}
